<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="avaliacoes"
      :sort-by="[{ key: 'id', order: 'asc' }]"
      :search="search"
      class="elevation-1"
    >
      <template #top>
        <ModalRealizarAvaliacao
          style="margin-right: 40px"
          @solicitacaoFechar="atualizarEstado"
          v-if="ativo"
          :ativo="true ? ativo : false"
          :id_avaliacao="this.idAval"
          :id_projeto="this.idProj"
        />
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.push('/projects')"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >{{ nomeProjeto }} - Avaliações</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            outline
            hide-details
            variant="underlined"
          ></v-text-field>

          <v-dialog v-model="dialog" max-width="700px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Visualizar Projeto</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        v-model="editedItem.nome"
                        label="Nome"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="editedItem.sigla"
                        label="Sigla"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Equipe</v-label>
                      <v-list
                        class="d-flex flex-wrap"
                        :min-width="150"
                        lines="one"
                      >
                        <v-list-item
                          v-for="item in equipeMembros"
                          :key="item.nomeEqui"
                          :title="item.nomeEqui"
                          :subtitle="`${item.formaAtuacao}`"
                        ></v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="editedItem.descricao"
                        label="Descrição"
                        readonly
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row class="justify-content-center mb-6">
                    <v-col cols="12"
                      ><v-btn
                        prepend-icon="mdi-github"
                        class="mr-4"
                        color="danger"
                        @click="githubDialog = true"
                        title="Associar este projeto ao Github"
                        >Github</v-btn
                      >

                      <v-btn
                        prepend-icon="mdi-account-group"
                        class="mr-4"
                        color="primary"
                        @click="verEquipe"
                        title="Definir equipe para este projeto"
                        >Equipe</v-btn
                      >

                      <v-btn
                        prepend-icon="mdi-cancel"
                        color="red"
                        @click="encerrar"
                        variant="outlined"
                        title="Encerrar este projeto"
                        >Encerrar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="justify-content-end">
          <v-btn
            prepend-icon=" mdi-clipboard-list-outline"
            variant="text"
            @click="showItem(item.raw)"
          >
            Avaliar Membros
          </v-btn>
          <v-btn
            prepend-icon=" mdi-clipboard-list-outline"
            variant="text"
            v-if="item.raw.idForm"
            @click="callFormView(item.raw)"
          >
            Responder Formulário
          </v-btn>
          <v-btn
            prepend-icon=" mdi-clipboard-list-outline"
            variant="text"
            v-if="item.raw.idForm"
            @click="callMyAvalView(item.raw)"
          >
            Visualizar como fui avaliado
          </v-btn>
        </div>
      </template>
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem avaliações a listar </span>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import ModalRealizarAvaliacao from '@/components/dialogs/ModalRealizarAvaliacao.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    ModalRealizarAvaliacao,
    SnackBar,
  },
  data: () => ({
    ativo: false,
    dialog: false,
    search: '',
    headers: [
      {
        title: '#',
        align: 'start',
        key: 'id',
        sortable: false,
      },
      { title: 'Titulo', key: 'titulo' },
      { title: 'Data Início', key: 'dataInicio' },
      { title: 'Data Fim', key: 'dataFim' },
      { title: 'Ações', align: 'center', key: 'actions', sortable: false },
    ],
    avaliacoes: [],
    idAval: null,
    idProj: null,
    editedIndex: -1,
    editedItem: {
      titulo: '',
      dataInicio: '',
      dataFim: '',
    },
    defaultItem: {
      titulo: '',
      dataInicio: '',
      dataFim: '',
    },
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.idAvaliacao = this.$route.params.id;
    this.nomeProjeto = this.$route.params.nome;
    this.fetchavaliacoes();
  },

  methods: {
    // Função de inicialização de avaliações,
    // sempre preenche com uma req ao back
    /* eslint-disable */
    /**
     * Busca a lista de avaliações a partir do backend e preenche o array de avaliaçao
     * @function
     * @name fetchavaliacoes
     * @memberof RatingsList
     * @returns {Promise<void>}
     */
    atualizarEstado(dadosDoFilho) {
      this.ativo = dadosDoFilho.solicitacao;
    },
    fetchavaliacoes() {
      axios
        .get(API_URL + `/avaliacoes/${this.idAvaliacao}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          let count = 1;
          response.data.forEach((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            /* eslint-enable */

            const dtinicio = new Date(element.tb_avaliacao.dtinicio);
            const dtfim = new Date(element.tb_avaliacao.dtfim);

            this.avaliacoes.push({
              id: count++,
              idAval: element.tb_avaliacao.id_avaliacao,
              idForm: element.tb_avaliacao.id_formulario,
              titulo: element.tb_avaliacao.titulo,
              dataInicio: `${dtinicio.getDate()}/${
                dtinicio.getMonth() + 1
              }/${dtinicio.getFullYear()}`,
              dataFim: `${dtfim.getDate()}/${
                dtfim.getMonth() + 1
              }/${dtfim.getFullYear()}`,
              idproj: element.id_projeto,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    /* eslint-disable */

    /**
     * Atualiza o estado de um item selecionado para ser editado e abre um diálogo para exibir as informações do item. Também faz uma requisição para obter os membros da equipe do item selecionado.
     *
     * @function showItem
     * @param {object} item - O objeto do item selecionado.
     * @returns {void}
     */
    showItem(item) {
      var avaliou = false;
      axios
        .get(
          API_URL + `/avaliacoes/avaliadores/${item.idproj}/${item.idAval}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          }
        )
        .then((response) => {
          response.data.tb_avaliacao_item.forEach((item) => {
            if (item.id_usuario_avaliador === store.state.idUsuario) {
              avaliou = !avaliou;
            }
          });
          if (!avaliou) {
            var dataAtual = new Date();

            var ano = dataAtual.getFullYear(); // Retorna o ano (ex: 2023)
            var mes = dataAtual.getMonth() + 1; // Mês começa de 0 (janeiro) a 11 (dezembro), então adicionamos 1
            var dia = dataAtual.getDate(); // Retorna o dia do mês (1 a 31)
            var dataFormatada = dia + '/' + mes + '/' + ano;

            if (this.parseDate(item.dataFim) >= this.parseDate(dataFormatada)) {
              this.idAval = parseInt(item.idAval);
              this.idProj = parseInt(item.idproj);
              this.ativo = true;
            } else {
              this.$refs.snackbar.showWarningSnackbar(
                'Atenção!',
                'Prazo máximo para a resposta da avaliação ultrapassado.'
              );
            }
          } else {
            this.$refs.snackbar.showWarningSnackbar(
              'Atenção!',
              'Você já respondeu essa avaliação.'
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    callViewRatingIndividual(item) {
      var idAvaliacao = item.idAval;
      this.$router.push({
        name: 'allRatingsIndividual',
        params: { id: parseInt(idAvaliacao), id_proj: parseInt(item.idproj) },
      });
    },
    parseDate(dateString) {
      var parts = dateString.split('/'); // Divide a string em partes usando '/'
      var day = parseInt(parts[0], 10); // Converte o dia em um número inteiro
      var month = parseInt(parts[1], 10) - 1; // Converte o mês em um número e subtrai 1 (janeiro é 0)
      var year = parseInt(parts[2], 10); // Converte o ano em um número inteiro
      return new Date(year, month, day); // Cria um objeto Date
    },
    callFormView(item) {
      var avaliou = false;
      axios
        .get(
          API_URL + `/avaliacoes/avaliadores/${item.idproj}/${item.idAval}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          }
        )
        .then((response) => {
          response.data.tb_avaliacao_item.forEach((item) => {
            if (item.id_usuario_avaliador === store.state.idUsuario) {
              avaliou = !avaliou;
            }
          });
          if (!avaliou) {
            var dataAtual = new Date();

            var ano = dataAtual.getFullYear(); // Retorna o ano (ex: 2023)
            var mes = dataAtual.getMonth() + 1; // Mês começa de 0 (janeiro) a 11 (dezembro), então adicionamos 1
            var dia = dataAtual.getDate(); // Retorna o dia do mês (1 a 31)
            var dataFormatada = dia + '/' + mes + '/' + ano;
            if (this.parseDate(item.dataFim) >= this.parseDate(dataFormatada)) {
              var idAvaliacao = item.idAval;
              this.$router.push({
                name: 'rating360',
                params: {
                  id: parseInt(idAvaliacao),
                  id_proj: parseInt(item.idproj),
                },
              });
            } else {
              this.$refs.snackbar.showWarningSnackbar(
                'Atenção!',
                'Prazo máximo para a resposta da avaliação ultrapassado.'
              );
            }
          } else {
            this.$refs.snackbar.showWarningSnackbar(
              'Atenção!',
              'Você já respondeu essa avaliação.'
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    callMyAvalView(item) {
      var dataAtual = new Date();

      var ano = dataAtual.getFullYear(); // Retorna o ano (ex: 2023)
      var mes = dataAtual.getMonth() + 1; // Mês começa de 0 (janeiro) a 11 (dezembro), então adicionamos 1
      var dia = dataAtual.getDate(); // Retorna o dia do mês (1 a 31)
      var dataFormatada = dia + '/' + mes + '/' + ano;

      if (this.parseDate(item.dataFim) < this.parseDate(dataFormatada)) {
        var idAvaliacao = item.idAval;
        this.$router.push({
          name: 'myRating360',
          params: { id: parseInt(idAvaliacao), id_proj: parseInt(item.idproj) },
        });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Atenção!',
          'O período para visualizar as respostas dessa avaliação ainda não começou.'
        );
      }
    },
    /**
     * Fecha o diálogo de visualizar de item e reseta o estado do item editado e da lista de membros da equipe.
     *
     * @function close
     * @returns {void}
     */
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.equipeMembros = [];
      });
    },
  },
};
</script>
<style scoped>
.d-flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
